import axios from 'axios'
import { servers } from '@/helpers'
import store from '@/store'

export const getResponses = async (query) => {
  let queryString = ''
  if (query['survey_group_id'] === '' || query['survey_group_id'] === 'All') {
    queryString = new URLSearchParams({ question_id: query['question_id'] })
  } else {
    queryString = new URLSearchParams({ question_id: query['question_id'], survey_group_id: query['survey_group_id'] })
  }
  let response = await axios.get(`${servers[store.state.auth.server].scores}/api/v1/responses/all?${queryString}`)
  return response.data.items
}
